import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, INTEGER, OBJECT } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'job'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      parameters: new OBJECT(),
      progress: new INTEGER(),
      progress_total: new INTEGER(),
      progress_percentage: new INTEGER(),
      attempts: new INTEGER(),
      status: new INTEGER(),
      result: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
